import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { COMPANY } from "@/lib/company";

export default function TermsConditions() {
  return (
    <div data-testid="terms-page" className="min-h-screen bg-white text-neutral-900">
      <header className="border-b border-neutral-200 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="terms-back">
            <div className="w-10 h-10 flex items-center justify-center bg-[#C5A059] text-white font-heading font-semibold">FT</div>
            <div>
              <p className="font-heading text-sm font-medium leading-tight">Fix Technical Renovation Company</p>
              <p className="text-[10px] uppercase tracking-[0.2em] text-[#C5A059]">Premier Interior Fitting · Dubai</p>
            </div>
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-neutral-600 hover:text-[#C5A059]">
            <ArrowLeft className="w-4 h-4" /> Back home
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <p className="text-[11px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-3">Legal</p>
        <h1 className="font-heading text-4xl lg:text-5xl font-light tracking-tight mb-8">Terms &amp; Conditions</h1>

        <div className="text-neutral-700 leading-relaxed space-y-6 text-base">
          <p>
            These terms govern the services provided by Fix Technical Renovation Company on this website. By submitting a request, you agree to the terms below.
          </p>

          <h2 className="font-heading text-2xl font-light text-neutral-900 mt-10">Services</h2>
          <p>
            Fix Technical Renovation Company provides apartment renovation, villa renovation, complete home renovation, kitchen remodeling, bathroom upgrades, custom joinery, premium flooring, gypsum ceiling, painting, electrical and plumbing works, and turn-key interior fit-out services in Dubai. All work is delivered as per the agreed scope captured in the final signed quotation.
          </p>

          <h2 className="font-heading text-2xl font-light text-neutral-900 mt-10">Site Inspection &amp; Quotation</h2>
          <p>
            Free site inspection is offered within selected Dubai areas, subject to appointment availability. Final pricing depends on site condition, material selection, authority approval requirements, building management requirements, and confirmed scope of work. Any government, authority, building management, or third-party approval fees are excluded unless clearly mentioned in the final quotation.
          </p>

          <h2 className="font-heading text-2xl font-light text-neutral-900 mt-10">Warranty</h2>
          <p>
            Warranty support applies only to approved and completed scope of work mentioned in the final quotation. Pre-existing conditions, third-party works, and items outside the agreed scope are excluded.
          </p>

          <h2 className="font-heading text-2xl font-light text-neutral-900 mt-10">Contact</h2>
          <p>
            Contact us at{" "}
            <a href={`mailto:${COMPANY.email}`} className="text-[#C5A059] underline">{COMPANY.email}</a>{" "}
            or {COMPANY.phone} / WhatsApp {COMPANY.whatsapp}. Office: {COMPANY.address}.
          </p>
        </div>
      </main>
    </div>
  );
}
